/*
 * A factory class used to create renderers for a specific Question type
 */
import QuestionTypeVersion from './QuestionTypeVersion';
import { ScriptsQuestionType } from '../core/enums/Enum';
import logIt from '../../logIt';

export default class QuestionTypeRendererFactory {
    async create(options) {
        if (!options) throw 'must specify valid options of QR Renderer to create';
        const type = options.msg.questionType;
        if (!type && !options.msg.agentScriptDocuments) throw 'must specify which type of QR Renderer to create';
        const renderers = this.renderers || (this.renderers = {});
        const uniqueness = {
            rendererId: `${type}_${options.msg.id}`
        };
        // if (renderers[uniqueness.rendererId])
        //  return renderers[uniqueness.rendererId];
        if (type == ScriptsQuestionType.TrueOrFalse) {
            if (options.version == QuestionTypeVersion.Classical) {

                const module = await import(/* webpackChunkName: "trueFalseMessageRenderer" */ './TrueFalseMessageRenderer')
                renderers[uniqueness.rendererId] = new module.default(
                    Object.assign(options, uniqueness)
                );
            } else {

                const module = await import(/* webpackChunkName: "rDTrueFalseMessageRenderer" */ './RDTrueFalseMessageRenderer')
                renderers[uniqueness.rendererId] = new module.default(
                    Object.assign(options, uniqueness)
                );
            }
        } else if (type == ScriptsQuestionType.Text && !options.aiBotEnabled) {

            //  if (options.version !== ApexChat.QuestionTypeVersion.Classical) {
            // TODO: Proper check required to run the contact info form, I will handle that in integration related ticket
            const module = await import(/* webpackChunkName: "contactInfoMessageRenderer" */ './ContactInfoMessageRenderer')
            renderers[uniqueness.rendererId] = new module.default(
                Object.assign(options, uniqueness)
            );
            //  }
        } else if (type == ScriptsQuestionType.Text && ApexChat.options.aiBotEnabled) {
            const module = await import(/* webpackChunkName: "userInfoMessageRenderer" */ './UserInfoMessageRenderer')
            renderers[uniqueness.rendererId] = new module.default(
                Object.assign(options, uniqueness)
            );
            //  }
        }
        else if (type == ScriptsQuestionType.AppointmentScheduler) {

            const module = await import(/* webpackChunkName: "appointmentScheduleRenderer" */ './AppointmentScheduleRenderer')
            renderers[uniqueness.rendererId] = new module.default(
                Object.assign(options, uniqueness)
            );
        } else if (type == ScriptsQuestionType.MultipleChoice) {
            if (options.msg.questionTypeDisplayListForVisitor && options.isBottomSheetSupported) {

                const module = await import(/* webpackChunkName: "mcBottomListMessageRenderer" */ './MCBottomListMessageRenderer')
                renderers[uniqueness.rendererId] = new module.default(
                    Object.assign(options, uniqueness)
                );
            } else {
                const module = await import(/* webpackChunkName: "mcListMessageRenderer" */ './MCListMessageRenderer')
                renderers[uniqueness.rendererId] = new module.default(
                    Object.assign(options, uniqueness)
                );
            }
        } else if (
            type == ScriptsQuestionType.TimeCalendar ||
            type == ScriptsQuestionType.CalendarDate ||
            type == ScriptsQuestionType.Time
        ) {
            if (options.isBottomSheetSupported && options.applyNewDateTime) {

                const module = await import(/* webpackChunkName: "dateTimeBottomListMessageRenderer" */ './DateTimeBottomListMessageRenderer')
                renderers[uniqueness.rendererId] = new module.default(
                    Object.assign(options, uniqueness)
                );
            }
        } else if (type == ScriptsQuestionType.AllThatApply) {
            if (options.msg.questionTypeDisplayListForVisitor && options.isBottomSheetSupported) {

                const module = await import(/* webpackChunkName: "ataBottomListMessageRenderer" */ './ATABottomListMessageRenderer')
                renderers[uniqueness.rendererId] = new module.default(
                    Object.assign(options, uniqueness)
                );
            } else {

                const module = await import(/* webpackChunkName: "ataMessageRenderer" */ './ATAMessageRenderer')
                renderers[uniqueness.rendererId] = new module.default(
                    Object.assign(options, uniqueness)
                );
            }
        } else if (type == ScriptsQuestionType.VideoGreet) {

            const module = await import(/* webpackChunkName: "greetVideoRenderer" */ './GreetVideoRenderer')
            renderers[uniqueness.rendererId] = new module.default(
                Object.assign(options, uniqueness)
            );

        } else if (type === ScriptsQuestionType.None) { // QT None renderer in files/documents attached case

            const module = await import(/* webpackChunkName: "guestionTypeNoneRenderer" */ './QuestionTypeNoneRenderer')
            renderers[uniqueness.rendererId] = new module.default(
                Object.assign(options, uniqueness)
            );
        } else {
            // return default renderer if type is not known Or is of type: Plain text
            const module = await import(/* webpackChunkName: "qtMessageRenderer" */ './QTMessageRenderer')
            renderers[uniqueness.rendererId] = new module.default(
                Object.assign(options, uniqueness)
            );
        }
        logIt(`renderer created:${JSON.stringify(uniqueness)}`);
        return renderers[uniqueness.rendererId];
    }

    destroy() {
        this.renderers = {};
    }
}
